import Vue from 'vue';

//initialize event bus
export const EventBus = new Vue();




// WEBPACK FOOTER //
// event.bus.js